/*
 * Created by Andrey Popov on 16.11.2023
 */

const SceneFilmEffect = cc.Node.extend({
    ctor: function (options) {
        this._super();

        options.scaleTimeout = options.scaleTimeout || 1;

        this.options = options;
        this.onShow = cleverapps.once(options.onShow);

        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER - 1);

        this.setContentSize2(cleverapps.resolution.getSceneSize());
        this.setAnchorPoint(0.5, 0.5);
        this.setAlignment({ align: "center" }, { align: "center" });

        this.topLayer = new FilmEffectLayer({ top: true, ...options });
        this.addChild(this.topLayer);

        this.bottomLayer = new FilmEffectLayer(options);
        this.addChild(this.bottomLayer);

        this.addControls();
        this.showAnimation();

        this.scheduleUpdate();
    },

    onResize: function () {
        this.onShow();
        this.removeFromParent();
    },

    update: function (dt) {
        this._super(dt);

        const scene = cleverapps.Scenes.GetRunningScene();
        const padding = cleverapps.resolution.getSafePadding();
        this.setScale(1 / scene.getScale());
        this.setAlignment(this.parent.convertToNodeSpace(cc.p(padding.left + scene.width / 2, scene.height / 2)));
    },
    
    addControls: function () {
        cleverapps.focusManager.setEventNodes([this]);
        cleverapps.pointerManager.create(this, {
            swallowEvents: true,
            onClick: function () {
                if (this.options.onClick) {
                    this.options.onClick();
                }
            }.bind(this)
        });
    },

    showAnimation: function () {
        const scene = cleverapps.Scenes.GetRunningScene();

        const moveByX = this.options.moveBy && this.options.moveBy.x || 0;
        let moveByY = this.options.moveBy && this.options.moveBy.y || 0;

        const layerHeight = moveByY > 0 ? this.bottomLayer.height : this.topLayer.height;
        const maxMoveByY = layerHeight + scene.height * (this.options.scale - 1) / 2;

        const targetPosition = scene.getPosition();

        if (Math.abs(moveByY) > maxMoveByY) {
            moveByY = cleverapps.sign(moveByY) * maxMoveByY;
        }

        targetPosition.x += moveByX;
        targetPosition.y += moveByY;

        this.topLayer.showAnimation();
        this.bottomLayer.showAnimation();

        this.stopCurrentAction();
        this.currentAction = scene.runAction(new cc.Sequence(
            new cc.DelayTime(this.options.layerTimeout),
            new cc.Spawn(
                new cc.MoveTo(this.options.scaleTimeout, targetPosition),
                new cc.ScaleTo(this.options.scaleTimeout, this.options.scale)
            ),
            new cc.CallFunc(this.onShow.bind(this))
        ));
    },

    hideAnimation: function (timeout, callback) {
        timeout = timeout || 0;
        callback = callback || function () {};

        const scene = cleverapps.Scenes.GetRunningScene();
        this.stopCurrentAction();

        const padding = cleverapps.resolution.getSafePadding();

        if (!timeout) {
            scene.setAlignment(padding.left, padding.bottom);
            scene.setScale(1);
            callback();
            if (this.pendingCallback) {
                this.pendingCallback();
            }
            return;
        }

        this.pendingCallback = callback;

        this.runAction(new cc.Sequence(
            new cc.DelayTime(timeout),
            new cc.CallFunc(callback),
            new cc.RemoveSelf()
        ));

        this.currentAction = scene.runAction(new cc.Spawn(
            new cc.MoveTo(timeout, cc.p(padding.left, padding.bottom)),
            new cc.ScaleTo(timeout, 1)
        ));

        this.topLayer.hideAnimation(timeout);
        this.bottomLayer.hideAnimation(timeout);
    },

    stopCurrentAction: function () {
        if (this.currentAction && !this.currentAction.isDone()) {
            cleverapps.Scenes.GetRunningScene().stopAction(this.currentAction);
            delete this.currentAction;
        }
    }
});